<template>
    <div
        v-if="isComponentReady"
        class="l-ss-c-offers"
        :class="wrapperClasses">
        <recommendations-wrapper
            :recommendations="recommendations"
            :view="options.view"
            ref="offersWrapper"
            @offer-click="params => $emit('offer-click', params)"
            @add-to-cart="offer => $emit('add-to-cart', offer)"/>
    </div>
</template>

<script>
    import { installPlugins } from '@/core/plugins';

    import RootComponentMixin from '@/core/mixins/root-component';
    import RecommendationsWrapper from '@/core/components/recommendations-wrapper';

    installPlugins();

    export default {
        components: {
            RecommendationsWrapper,
        },
        props: {
            ...RootComponentMixin.props,
            recommendations: {
                type: Array,
                default: () => ([]),
            },
        },
        computed: {
            ...RootComponentMixin.computed,
        },
        mounted() {
            this.$nextTick(() => {
                if ('IntersectionObserver' in window && this.wrapperElement instanceof Element) {
                    const observer = new IntersectionObserver((entries, observer) => {
                        if ((entries || []).length > 0 && entries[0].isIntersecting) {
                            this.$refs.offersWrapper.handleArrows();
                            observer.disconnect();
                        }
                    });
                    observer.observe(this.wrapperElement);
                }
            });
        },
    };
</script>

<style scoped>

</style>